<template>
  <div class="discounts-container">
    <div v-for="(config, type) in filteredConfigs" :key="type" class="col-12 table-discounts">
      <app-title :label="config.label" />
      <table>
        <thead>
          <tr>
            <th v-for="column in config.columns" :key="column.field">{{ column.label }}</th>
            <th v-if="addExpireButton(config.label)">EXPIRAR PROMO</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="discount in getDiscountsByType(type)" :key="discount.clientId">
            <td v-for="column in config.columns" :key="column.field">
              {{ getDiscountValue(discount, column.field) }}
            </td>
            <td v-if="addExpireButton(config.label)">
              <button
                v-if="!isExpired(discount)"
                class="btn btn-danger btn-sm"
                style="font-size: 10px"
                @click="onSubmitExpireCode(discount)"
              >
                Expirar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { appTitle } from 'tb-design_system-web'
import { computed } from 'vue'

export default {
  name: 'tableDiscounts',
  components: { appTitle },

  props: {
    discounts: {
      type: Array,
      default: () => []
    }
  },

  setup(props, { emit }) {
    const discountsConfig = {
      PROMOCODE: {
        label: 'PROMOCODE',
        columns: [
          { label: 'CLIENTE', field: 'clientId' },
          { label: 'PROMOCODE', field: 'promoCode' },
          { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
          { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' },
          { label: 'EXPIRA EM', field: 'promoCodeEndsAt' }
        ]
      },
      INDICATE_AND_WIN: {
        label: 'INDIQUE E GANHE',
        columns: [
          { label: 'CLIENTE', field: 'clientId' },
          { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
          { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' },
          { label: 'QUANT. UTILIZADA', field: 'accumulation' }
        ]
      },
      INDICATE_AND_WIN_FIRST_TIME_OPERATION: {
        label: 'INDIQUE E GANHE NA PRIMEIRA OPERAÇÃO',
        columns: [
          { label: 'CLIENTE', field: 'clientId' },
          { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
          { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' }
        ]
      },
      PROMOCODE_GIFT_CARD: {
        label: 'GIFT CARD',
        columns: [
          { label: 'CLIENTE', field: 'clientId' },
          { label: 'PROMOCODE', field: 'promoCode' }
        ]
      }
    }

    const getDiscountsByType = (type) =>
      props.discounts.filter((discount) => discount.type === type)

    const filteredConfigs = computed(() => {
      return Object.keys(discountsConfig)
        .filter((type) => getDiscountsByType(type).length > 0)
        .reduce((obj, key) => {
          obj[key] = discountsConfig[key]
          return obj
        }, {})
    })

    const addExpireButton = (label) => {
      if (!['PROMOCODE', 'GIFT CARD'].includes(label)) return false
      const type = Object.keys(discountsConfig).find((key) => discountsConfig[key].label === label)
      return getDiscountsByType(type).some((d) => !isExpired(d))
    }

    const isExpired = (discount) => {
      if (!discount.promoCodeEndsAt) return false
      const date = new Date(discount.promoCodeEndsAt)
      if (date.getFullYear() >= 2999) return false
      return date <= new Date()
    }

    const onSubmitExpireCode = async (promocode) => {
      emit('expirePromocode', promocode.promoCode)
    }

    const getDiscountValue = (discount, field) => {
      if (field === 'spreadDiscountPercentage' && discount.spreadConstantPercentageEnabled) {
        return `FIXO: ${discount.spreadConstantPercentage}%`
      }

      if (field === 'clientTaxDiscountPercentage' && discount.clientTaxConstantValueEnabled) {
        return `FIXO: USD ${discount.clientTaxConstantValue.toFixed(2)}`
      }

      if (field === 'spreadDiscountPercentage' || field === 'clientTaxDiscountPercentage') {
        return discount[field] != null ? `${discount[field]}%` : 'N/A'
      }

      if (field === 'promoCodeEndsAt') {
        if (discount[field] == null) {
          return ''
        }
        const date = new Date(discount[field])
        if (date.getFullYear() >= 2999) {
          return 'Sem expiração'
        }
        return format(date, 'dd/MM/yy')
      }

      return discount[field] != null ? discount[field] : 'N/A'
    }

    return {
      filteredConfigs,
      getDiscountsByType,
      getDiscountValue,
      addExpireButton,
      isExpired,
      onSubmitExpireCode
    }
  }
}
</script>

<style scoped lang="scss">
.table-discounts {
  margin-bottom: 20px;
  table {
    tbody {
      tr {
        td {
          color: var(--label-color);
        }
      }
    }
  }
}
</style>
